module.exports = __webpack_public_path__ + "img/ProdBlockImg.a48c9ea9.png";